import { isPlatformBrowser, NgClass, NgIf } from "@angular/common";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, HostListener, Inject, Input, OnDestroy, OnInit, PLATFORM_ID, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from "@angular/forms";
import { NavigationEnd, Router, RouterLink } from "@angular/router";
import { IconPlayComponent } from "@src/app/components/svg/icon-play/icon-play.component";
import { Orientation } from "@src/app/models/enums/orientation.enum";
import { DeviceService } from "@src/app/servicios/device/device.service";
import { ReelsService } from "@src/app/servicios/reels.service";
import { CookieService } from "ngx-cookie-service";
import { filter, Subscription } from "rxjs";
import { KebabCasePipe } from "src/app/pipes/kebab-case.pipe";
import { IframeService } from "../../servicios/iframe/iframe.service";
import { PlatformService } from "src/app/servicios/platform/platform.service";
import { SidenavService } from "src/app/servicios/sidenav/sidenav.service";
import { environment } from "../../../environments/environment";
import { IconPauseComponent } from "../../components/svg/icon-pause/icon-pause.component";
import { Icon24HoursComponent } from "../icon-24-hours/icon-24-hours.component";
import { IconCarouselComponent } from "../icon-carousel/icon-carousel.component";
import { IconLogOutComponent } from "../icon-log-out/icon-log-out.component";
import { IconRedCircleComponent } from "../icon-red-circle/icon-red-circle.component";
import { IconReelsComponent } from "../icon-reels/icon-reels.component";
import { IconSearchComponent } from "../icon-search/icon-search.component";
import { IconUserComponent } from "../icon-user/icon-user.component";
import { IconViewNewsComponent } from "../icon-view-news/icon-view-news.component";
import { IconMenuBurguerComponent } from "../icon-menu-burguer/icon-menu-burguer.component";
import { ModalLoginComponent } from "../modal-login/modal-login.component";
@Component({
  selector: "app-header-movil",
  templateUrl: "./header-movil.component.html",
  styleUrls: ["./header-movil.component.scss"],
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule, NgClass, NgIf, RouterLink, IconSearchComponent, IconRedCircleComponent, Icon24HoursComponent, IconViewNewsComponent, IconReelsComponent, IconCarouselComponent, IconUserComponent, IconLogOutComponent, IconPauseComponent, IconPlayComponent, ModalLoginComponent, IconMenuBurguerComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderMovilComponent implements OnInit, OnDestroy {
  @Input() configPrensa: any;
  boolAudio: boolean = false;
  mostrarBuscador = false;
  configBloque: any;
  configBloqueNewsletter: any;
  reelsPortada = false;
  hideOrientation: boolean = undefined;
  prevScrollPos;
  showBloque = false;
  showBuscador = false;
  showReels = false;
  showLogin = false;
  showRadio = false;
  show24h = false;
  urlRadio: any;
  icono24h: any;
  iconoRadio: any;
  userLogin: boolean = false;
  isInIframe: boolean = false;
  scrollSub: Subscription;
  scrollSubscription: Subscription;
  navigationSub: Subscription;
  currentMode: Orientation;
  searchForm: FormGroup;
  @ViewChild("buscadorRef") buscadorRef: ElementRef;
  @ViewChild("audioRadio") audioRadio: ElementRef;

  showLoginModal: boolean = false;

  private orientationSub: Subscription;

  constructor(
    private readonly platformService: PlatformService,
    private readonly sidenav: SidenavService,
    private readonly router: Router,
    private readonly kebabPipe: KebabCasePipe,
    private readonly fb: FormBuilder,
    private readonly elementRef: ElementRef,
    private readonly cookieService: CookieService,
    private readonly deviceService: DeviceService,
    private readonly reelsService: ReelsService,
    private readonly cdr: ChangeDetectorRef,
    private readonly iframeService: IframeService,
    @Inject(PLATFORM_ID) private readonly platformId,
  ) {
    this.searchForm = this.fb.group({
      search: ["", [Validators.required]],
    });
    if (this.platformService.isBrowser()) {
      requestAnimationFrame(() => {
        this.prevScrollPos = window.scrollY;
      });

      // ✅ DETECCIÓN TEMPRANA DE IFRAME (Síncrona y robusta)
      const urlParams = new URLSearchParams(window.location.search);
      const isInIframeParam = urlParams.get("inIframe") === "true";
      this.isInIframe = isInIframeParam || (window.self !== window.top);

      if (this.isInIframe) {
        // Marcamos isInIframe, pero no forzamos showBloque a true
        // ya que el usuario quiere ocultar el header móvil en iframes.
      }
    }

    this.sidenav.setIsScrolled(false);
    this.sidenav.setLogoVisibility(false);
  }

  ngOnInit(): void {
    if (this.router?.events) {
      this.navigationSub = this.router.events.pipe(filter((evt) => evt instanceof NavigationEnd)).subscribe(() => {
        this.reelsService.setOrientation(this.currentMode);
      });
    }

    if (this.platformService.isBrowser()) {
      const cookieValue = this.cookieService.get("userLogin" + environment.name);
      if (cookieValue) this.userLogin = JSON.parse(cookieValue);
    }

    if (this.configPrensa) {
      const selectorName = this.elementRef.nativeElement.tagName.toLowerCase();
      this.configBloque = this.configPrensa.general[selectorName];
      this.showBloque = this.configBloque.bloque_activo === "true";
      if (this.showBloque) {
        this.showBuscador = this.configBloque.mostrar_buscador === "true";
        this.showLogin = this.configBloque.mostrar_login === "true";
        this.showReels = this.configBloque.mostrar_reels === "true";
        this.icono24h = this.configBloque.icono_24h;
        this.show24h = this.configBloque.mostrar_24h === "true";
        this.showRadio = this.configBloque.mostrar_radio === "true";
        this.urlRadio = this.configBloque.url_radio;
        this.iconoRadio = this.configBloque.icono_radio;
      }

      // ✅ DETECCIÓN DE IFRAME (Refuerzo en ngOnInit)
      if (this.platformService.isBrowser() && !this.isInIframe) {
        if (window.self !== window.top) {
          this.isInIframe = true;
          this.cdr.detectChanges();
        }
      }

      this.reelsPortada = this.configPrensa.general["app-home"].portada_reels_movil === "true";
      const isReelsPortada = false;
      this.reelsService.setIsReels(isReelsPortada);
      this.updateCurrentMode();
      if (isReelsPortada && this.deviceService.isMobile()) {
        this.reelsService.setOrientation(Orientation.Vertical);
      }
      this.configBloqueNewsletter = this.configPrensa["app-newsletter"];
    }

    this.reelsService.hideOrientation$.subscribe((value) => {
      this.hideOrientation = value;
    });
  }

  ngOnDestroy(): void {
    if (this.scrollSub) this.scrollSub.unsubscribe();
    if (this.scrollSubscription) this.scrollSubscription.unsubscribe();
    this.orientationSub?.unsubscribe();
    this.navigationSub?.unsubscribe();

    if (isPlatformBrowser(this.platformId)) {
      localStorage.removeItem("currentOrientation");
    }
  }

  updateCurrentMode(): void {
    this.orientationSub = this.reelsService.orientation$.subscribe((value) => {
      this.currentMode = value;

      this.cdr.detectChanges();
    });
  }

  onReelsClick(event: any): void {
    this.currentMode = event;
    this.reelsService.setOrientation(this.currentMode);
    this.reelsService.setIsMobile(true);
    if ((this.router.url.includes("/reels") || this.router.url === "/") && this.currentMode === "clasico") {
      this.reelsService.setIsReels(false);
      this.router.navigate(["/"]);
    } else if ((this.router.url === "/" && (this.currentMode === "vertical" || this.currentMode === "horizontal")) || (this.router.url.includes("/reels") && this.currentMode === "horizontal")) {
      this.reelsService.setIsReels(true);
      this.router.navigateByUrl("/reels");
    }
  }

  /**
   * La función `clickBusqueda` elige entre mostrar una barra de búsqueda y enviar una solicitud de
   * búsqueda dependiendo del valor de `mostrarBuscador`.
   */
  clickBusqueda(): void {
    if (this.mostrarBuscador) this.enviarBusqueda();
    else this.mostrarBuscar();
  }

  /**
   * La función "enviarBusqueda" se utiliza para manejar la funcionalidad de búsqueda obteniendo el
   * valor de búsqueda y navegando a la página de búsqueda.
   * @returns Si `searchValue` no está vacío o solo contiene caracteres de espacio en blanco, la
   * función no devolverá nada, saliendo de la misma.
   */
  private enviarBusqueda(): void {
    if (!this.mostrarBuscador) return;
    const searchValue = this.searchForm.get("search").value;
    if (!searchValue.trim()) return;
    const busqueda = "/buscar/" + this.kebabPipe.transform(searchValue.trim());
    this.router.navigateByUrl(busqueda);
    this.searchForm.get("search").reset();
    this.mostrarBuscador = false;
  }

  /**
   * La función "mostrarBuscar" establece el valor de "mostrarBuscador" en verdadero si actualmente es
   * falso.
   */
  private mostrarBuscar(): void {
    this.mostrarBuscador = this.mostrarBuscador === false;
  }

  playPause(): void {
    const audio = this.audioRadio.nativeElement;

    if (!this.boolAudio) audio.play();
    else audio.pause();

    this.boolAudio = !this.boolAudio;
  }

  @HostListener("document:click", ["$event"])
  clickout(event) {
    if (!this.platformService.isBrowser() || !this.mostrarBuscador) return;
    if (!this.buscadorRef.nativeElement.contains(event.target)) {
      this.mostrarBuscador = false;
    }
  }

  logout(): void {
    this.cookieService.delete("userLogin" + environment.name);
    if (!this.platformService.isBrowser()) return;
    window.location.reload();
  }

  openSidenav(): void {
    this.sidenav.openSidenav();
  }
}
